/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import PropTypes from 'prop-types';
import FormFields from "./fromField";
import { getValidationRules } from "../../utils/Validation/GetValidationRule";
import { ValidateAll, Validate } from "../../utils/Validation/Validation";

const FormCreator = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(props.initialState);
  const [validState, setValidState] = useState({
    isValid: true,
    error: {},
  });
  const [validationRules, setValidationRules] = useState({});

  useEffect(() => {
    if (props.formSetting && props.formSetting.isViewOnly) {
      const valRule = getValidationRules(props.formFields);
      setValidationRules(valRule);
      return;
    }
    const valRule = getValidationRules(props.formFields);
    setValidationRules(valRule);
  }, [props.formFields]);

  // reset the initial state 
  useEffect(() => {
    setFormData(props.initialState);
    setValidState({
      isValid: true,
      error: {},
    });

    return () => {

    }
  }, [props.initialState]);

  useImperativeHandle(
    ref,
    () => {
      return {
        getFormData: () => {
          if (isValidForm())

            return formData;
        },
      };
    },
    [formData, validState, validationRules],
  );

  const isValidForm = () => {
    const validation = ValidateAll(formData, validationRules);
    if (!validation.isValid) {
      setValidState(validation);

    }
    return validation.isValid;
  };

  const handleStateChange = (updatedData) => {
    setFormData(updatedData);
  };

  const handleOnValidateField = (dataField) => {

    let validationObj = { ...validState }

    if (validationRules[dataField]) {
      const validation = Validate(formData, validationRules, dataField);
      if (!validation.isValid) {

        validationObj.error[dataField] = validation.error[dataField];
        validationObj.isValid = false;
        setValidState(validationObj);
      }
      else {

        if (validationObj.error[dataField]) {
          delete validationObj.error[dataField];
          setValidState(validationObj);

        }

      }
    }
  };

  return (
    <>
      {props.formFields ? (
        <FormFields
          fields={props.formFields}
          formData={formData}
          validState={validState}
          onFormStateChange={handleStateChange}
          onUpdateValidation={handleOnValidateField}
          formSetting={props.formSetting}
        />
      ) : (
        <div>No fields configured</div>
      )}
    </>
  );
});

FormCreator.propTypes = {
  name: PropTypes.string,
  initialState: PropTypes.object,
  formFields: PropTypes.array,
  onFormDataUpdate: PropTypes.func,
};

export default FormCreator;